// extracted by mini-css-extract-plugin
export default {"tablePagination":"TablePagination_tablePagination__AbjIj"};